import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('expenses', { params }))
  },

  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('expense?ex_id=' + data.ex_id))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('expense', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('expense', data, options))
  },

  async updateStatus (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('expense/status', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('expense', { data: data }, options))
  },

  async getLatestCode () {
    return store.dispatch('checkResponseApi', await Api().get('expense/latest_code'))
  },

  async getDescriptionLists () {
    return store.dispatch('checkResponseApi', await Api().get('expense/description_lists'))
  },
}



// WEBPACK FOOTER //
// ./src/api/ExpenseService.js